import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Button from "@material-ui/core/Button"
import { TextField } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Autocomplete from '@material-ui/lab/Autocomplete'
//*antd
import Modal from 'antd/es/modal';
import 'react-toastify/dist/ReactToastify.css'
//*Styles and Assets
import { TelematicsStyles } from '../TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../../actions/common/NavigationActions'
import * as TelematicsActions from '../../../actions/telematics/TelematicsActions'
import { Backdrop, CircularProgress } from '@material-ui/core'

const RegisterTechnician = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory()

    const [name, setName] = useState()
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()
    const [phoneType, setPhoneType] = useState([]);

    const [openBackdrop, setOpenBackdrop] = useState(false);

    const saveTechnician = {
        "name": name,
        "email": email,
        "phone": phone,
        "idPhoneType": phoneType,
        "branchOfficeId": Number(props.match.params.branchOfficeId)
    }

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/telematics/CatalogInstaller/',
            linkLegend: t('telematicsInstallers.technicianCatalog'),
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Phone_Types(props.userLanguage, props.userToken, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    //*First Render Functions
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    //*Save Functions
    const handleSave = () => {
        if (name !== undefined && email !== undefined && phone !== undefined && phoneType !== undefined) {
            props.actions.save_Technicians(props.userLanguage, props.userToken, saveTechnician, onError, onSuccessSave)
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const onSuccessSave = () => {
        Modal.success({
            title: t('commonMessages.savedSucc')
        })
        setPhoneType([])
        Array.from(document.querySelectorAll("input")).forEach(
            input => (input.value = "")
        )
        props.actions.fetch_Technicians(props.userLanguage, props.userToken, props.match.params.branchOfficeId, onError, onSuccess)
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.alert500')}</Typography>
                    })
                    break
                default:
                    break
            }
        }
    }

    return (
        <Container className={classes.generalBorder}>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid item xs={12}><br /></Grid>
            <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                <Grid item xs={5}>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsInstallers.technicianName')}</Typography>
                    <TextField onChange={e => setName(e.target.value)} variant="outlined" size="small" fullWidth />
                </Grid>
                <Grid item xs={2}><br /></Grid>
                <Grid item xs={5}>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.email')}</Typography>
                    <TextField onChange={e => setEmail(e.target.value)} variant="outlined" size="small" fullWidth />
                </Grid>
            </Grid>
            <Grid item xs={12}><br /></Grid>
            <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                <Grid item xs={5}>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.telephoneNumber')}</Typography>
                    <TextField
                        type="tel"
                        min="0"
                        error={phone < 0}
                        onChange={e => setPhone(e.target.value)}
                        helperText={phone < 0 ? t('commonMessages.noLess') : ''}
                        inputProps={{
                            pattern: "[0-9]"
                        }}
                        variant="outlined" size="small" fullWidth />
                </Grid>
                <Grid item xs={2}><br /></Grid>
                <Grid item xs={5}>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsInstallers.phoneType')}</Typography>
                    <Autocomplete
                        disableClearable={true}
                        onChange={(event, newValue) => {
                            setPhoneType(newValue.id);
                        }}
                        fullWidth={true}
                        size="small"
                        options={props.phoneTypeList}
                        getOptionLabel={(option) => option.description}
                        getOptionSelected={(option, value) => option.description === value.description}
                        renderInput={(params) => <TextField {...params} style={{ width: 480 }} label={''} variant="outlined" />}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}><br /></Grid>
            <Grid item xs={12} className={classes.buttonAlign}>
                <Button onClick={handleSave} variant="outlined" className={classes.generalBorder}>{t('common.save')}</Button>
            </Grid>
            <Grid item xs={12}><br /></Grid>
        </Container>
    )
}

const mapStateToProps = state => ({
    technicianList: state.TelematicsReducer.technicianList,
    phoneTypeList: state.TelematicsReducer.phoneTypesList,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(RegisterTechnician))